<div class="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-900">
  <div class="w-full max-w-sm rounded border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-800">
    <h1 class="mb-1 text-xl font-semibold">{{ 'auth.appTitle' | translate }}</h1>
    <p class="mb-4 text-sm text-gray-500">
      {{ 'auth.devNotice' | translate }}
    </p>

    @if (error()) {
      <div class="mb-3 text-sm text-red-600">{{ error() }}</div>
    }

    <form class="flex flex-col gap-3" (ngSubmit)="signIn()">
      <div>
        <label class="mb-1 block text-sm font-medium">{{ 'auth.username' | translate }}</label>
        <input type="text" pInputText class="w-full" name="username" [ngModel]="username()" (ngModelChange)="username.set($event)" />
      </div>
      <div>
        <label class="mb-1 block text-sm font-medium">{{ 'auth.password' | translate }}</label>
        <input type="password" pInputText class="w-full" name="password" [ngModel]="password()" (ngModelChange)="password.set($event)" />
      </div>
      <p-button
        type="submit"
        [label]="'auth.signIn' | translate"
        [disabled]="signingIn() || !username().trim() || !password()"
        styleClass="w-full"
      />
    </form>
  </div>
</div>
